import { reverse, ifElse, equals, always, concat } from 'ramda'
import { useState, useEffect } from 'react'

const getPath = ifElse(
    equals('tribe_events'),
    always('tribe/events/v1/events'),
    concat('wp/v2/')
);

const parseDateString = (date) => {
    return date.split('').slice(0, 10).join('')
}

const setQueryParams = (url, query = {}) => {
    const {
        perPage = 100,
        orderBy = 'date',
        order = 'desc',
        embed = true,
        startDate,
        endDate,
        search = '',
        categories = '',
        ...otherParams
    } = query
    url.searchParams.set('_embed', embed)
    url.searchParams.set('per_page', perPage)
    if (categories) { url.searchParams.set('search', search) }
    if (categories) { url.searchParams.set('categories', categories) }
    url.searchParams.set('orderby', orderBy)
    url.searchParams.set('order', order)

    if (startDate) {
        url.searchParams.set(
            'start_date',
            `${parseDateString(startDate)} 00:00:00`
        )
    }

    if (endDate) {
        url.searchParams.set(
            'end_date',
            `${parseDateString(endDate)} 23:59:00`
        )
    }

    for (const key in otherParams) {
        const isEmpty = !otherParams[key]
            || (Array.isArray(otherParams[key]) && otherParams[key].length < 1)
        if (isEmpty) continue
        url.searchParams.set(key, otherParams[key])
    }

    return url
}

export const useFetchPosts = (props = {}) => {
    const {
        query,
        endpoint,
        initialValue = []
    } = props;
    const [posts, setPosts] = useState(initialValue)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)



    const fetchPosts = async (query = {}) => {
        const {
            types = [],
            ...otherParams
        } = query
        try {
            const allResults = []
            if (types && types.length > 0) {
                setIsLoading(true)

                for (const type of types) {

                    const url = setQueryParams(new URL(`${endpoint}${getPath(type)}`), otherParams)

                    const { events = [] } = await fetch(url.href).then(r => r.ok ? r.json() : [])
                    for (const event of events) {
                        allResults.push(event)
                    }
                }
                setIsLoading(false)
            }

            setPosts(allResults.sort((a, b) => {
                const sorted = query.orderBy === 'date'
                    ? Date.parse(a.date) - Date.parse(b.date)
                    : a[query.orderBy] - b[query.orderBy]
                return query.order === 'desc' ? reverse(sorted) : sorted
            }))

        } catch (error) {
            setError(error)
        }
    }

    useEffect(() => {
        fetchPosts(query)
    }, [])
    return { posts, fetchPosts, error, isLoading }
}

export default useFetchPosts